import React, { Component } from 'react';

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div>
                <p>
                </p>
                <h2>BICSI Cares Professional Development and Scholarship Fund: Making A Difference Thanks to You.</h2>
                <p>
                    The BICSI Cares Professional Development and Scholarship fund is a year-round fund raising effort designed to support and promote the ICT Community in a variety of ways,
                    including supporting a  <a href="https://www.bicsi.org/membership-global-community/membership/women-in-bicsi" target="_blank">Women in BICSI</a> candidate for the BICSI
                    Cabling Skills Challenge, (powered by the Emerging Professionals & Student Workgroup) as well as providing education through BICSI training courses and other career development opportunities.
                </p>
                <p>
                    Donate today to show your support for future ICT professionals!
                </p>
                
            </div>
        );
    }
}
